module.exports = __webpack_public_path__ + "static/media/no-customers.fc1cd43b.svg";